export const BqFormErrorText = (props: { error?: string }) => {
  if (props.error) {
    return <div className="bq-form-error-text">{props.error}</div>;
  } else {
    return null;
  }
};
